import React from 'react';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';

export default function MainAppLayout({ children }) {
  return (
    <div
      style={{
        display: "flex",
        minHeight: "100vh",
        backgroundColor: "#f9fafb",
        margin: 0,
        padding: 0,
      }}
    >
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <div
        style={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          margin: 0,
          padding: 0,
        }}
      >
        {/* Header */}
        <Header />

        {/* Routes */}
        <main
          style={{
            flexGrow: 1,
            overflowY: "auto",
            margin: 0,
            padding: 0,
          }}
        >
          {children}
        </main>
      </div>
    </div>
  );
}
